import { useEffect } from "react";
import useStore from "./zustand/useStore";
import SearchBar from "./components/SearchBar";
import FilterBar from "./components/FilterBar";
import FilterChips from "./components/FilterChips";
import ListTypeFilter from "./components/ListTypeBar";
import ListView from "./components/ListView";
import CardView from "./components/CardView";

import "./App.css";

const App = () => {
  const { updateSettings, updateData, filters, view } = useStore((state) => ({
    updateSettings: state.updateSettings,
    updateData: state.updateData,
    filters: state.filters,
    view: state.view,
  }));
  useEffect(() => {
    const getWPSettings = async () => {
      await updateSettings();
    };
    const getData = async () => {
      await updateData();
    };
    getWPSettings();
    getData();
  }, [updateData, updateSettings]);
  return (
    <div className="App ituContainer">
      {/* Search bar */}
      <SearchBar />
      {/* Filters */}
      <FilterBar />
      {filters.search.length > 0 ||
      filters.date.length > 0 ||
      filters.country.length > 0 ||
      filters.type.length > 0 ? (
        <FilterChips />
      ) : null}
      {process.env.NODE_ENV === "development" ? <ListTypeFilter /> : null}

      {/* Data grid */}
      {view === "list" ? <ListView /> : <CardView />}
    </div>
  );
};

export default App;
